import { render, staticRenderFns } from "./rewardOnePlusSixEdit.vue?vue&type=template&id=325f059c&scoped=true&"
import script from "./rewardOnePlusSixEdit.vue?vue&type=script&lang=js&"
export * from "./rewardOnePlusSixEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f059c",
  null
  
)

export default component.exports